const apiUrl = process.env.REACT_APP_API_URL;

export const PostBbddPracticaIdCopy = async (idPrac: string, body: any): Promise<any> => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/practica/${idPrac}/copy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error('Error al copiar la pràctica');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching PostBbddPracticaIdCopy:', error);
        throw error;
    }
};
